const MIN_SCALE = 1;
const MAX_SCALE = 1.3;

export function initImageFeatureParallax() {
	const blocks = document.querySelectorAll('[data-image-feature-parallax]');
	if (!blocks.length) {
		return;
	}

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		blocks.forEach((block) => {
			if (block instanceof HTMLElement) {
				const inner = block.querySelector('.image-feature-block__inner');
				if (inner instanceof HTMLElement) {
					inner.style.setProperty('--if-parallax-scale', String(MIN_SCALE));
				}
			}
		});
		return;
	}

	let ticking = false;

	const update = () => {
		const viewportHeight = Math.max(window.innerHeight || 0, 1);

		blocks.forEach((block) => {
			if (!(block instanceof HTMLElement)) {
				return;
			}

			const inner = block.querySelector('.image-feature-block__inner');
			if (!(inner instanceof HTMLElement)) {
				return;
			}

			const rect = inner.getBoundingClientRect();
			const start = viewportHeight + rect.height * 0.2;
			const end = -rect.height * 0.35;
			const range = Math.max(1, start - end);
			const progress = clamp((start - rect.top) / range, 0, 1);
			const scale = MIN_SCALE + progress * (MAX_SCALE - MIN_SCALE);

			inner.style.setProperty('--if-parallax-scale', scale.toFixed(4));
		});

		ticking = false;
	};

	const requestUpdate = () => {
		if (ticking) {
			return;
		}

		ticking = true;
		window.requestAnimationFrame(update);
	};

	window.addEventListener('scroll', requestUpdate, { passive: true });
	window.addEventListener('resize', requestUpdate);
	window.addEventListener('load', requestUpdate);

	requestUpdate();
}

function clamp(value, min, max) {
	return Math.min(max, Math.max(min, value));
}
